import _ from 'lodash';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { Cell } from '@/main/utils/table';
import { DEFAULT } from '@/main/store/listEditTypes';
import { updateEditActionNoLoading } from '@/main/store/actionsFunctions';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
		VyrobekndOzn: [],
		VydejMjId: [],
		Mrp:[],
		TechniciansList:[],
		ServiceJobsList:[],
		CombinedMrpDnp:[]
	},
	edit: {
		EditDat: null as string | null,
		EditPracId: null as number | null,
		EditPracIdText: null as string | null,
		NdNr: null as string | null,
		NdNrNavrh: null as string | null,
		OzakazkaId: null as number | null,
		OzakazkaIdNr: null as number | null,
		OzakazkandId: null as number | null,
		OzakazkaIdText: null as string | null,
		PretacPzn: null as number | null,
		SkladOzn: null as number | null,
		StavRezerv: null as number | null,
		Text: null as string | null,
		VstupDat: null as string | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		VstupProvId: null as number | null,
		VydejMjId: null as number | null,
		VydejMjPoc: null as number | null,
		VyrobekndOzn: null as string | null,
		VyrobekndOznNavrh: null as string | null,
		ZakazkaId: null as number | null,
		ZakazkaIdNr: null as number | null,
		ZakazkaIdDruh: null as string | null,
		ZakazkandextodpisId: null as number | null,
		ZaznamId: null as number | null,
		EanCode: null as string | null,
		StockStatus: null as string | null,
		Flag: 1,
		IsAdditional: null as boolean | null,
		SkladMjText: null as string | null,
		Mrp: null as number | null,
		MrpId: null as number | null,
		RrpUnitPrice: null as number | null,
		TechnicianId: null as number | null,
		ServiceJobId: null as number | null,

	},
	localState: {
		isQuantityZero: null as boolean | null,
	},
	depTableNames: [],
	depTableSettings: {},
	extraActions: {
		[DEFAULT]: ({ state, commit, dispatch }, filter:{}) => (
			updateEditActionNoLoading(state, commit, dispatch,
				state.props.jfnd.row ? apiProvider.defaultJfnd(state.props.jfnd) : apiProvider.default(filter))
		),
	},
	extraGetters: {},
	extraMutations: {
		[types.mutations.NDREZ_ZAKAZKA_SELECT_MAPPER](state, { data }) {
			state.edit.ZakazkaId = data.value;
			state.edit.ZakazkaIdDruh = data.text;
			state.edit.ZakazkaIdNr = data.nr;
		},
		async [types.mutations.NDREZ_ND_SKLAD_SELECT_MAPPER](state, { data }) {
			state.edit.NdNr = data.ndnr;
			state.edit.Text = data.text;
			state.edit.VydejMjId = data.vydejmjid;
			if (data.quantity <= 0) {
				state.localState.isQuantityZero = true;
			}
			if(state.edit.ZaznamId === null || state.edit.ZaznamId! <= 0 && state.edit.SkladOzn != null) {
		     	const mrpDropdown = await apiProvider.getPricingDate(
				  state.edit.NdNr!,
				  state.edit.VyrobekndOzn!,
				  state.edit.ZakazkaId!,
				  state.edit.SkladOzn!
				)
				state.dropdownList.Mrp = mrpDropdown.data;
				if(mrpDropdown.data.length > 0) {
					state.edit.MrpId = mrpDropdown.data[0].Value
				}
			}
		}, 
		[types.mutations.NDREZ_OZAKAZKA_SELECT_MAPPER](state, { data }) {
			state.edit.OzakazkaId = data.value;
			state.edit.OzakazkaIdText = data.text;
			state.edit.OzakazkaIdNr = data.nr;
		},
		[types.mutations.NDREZ_STORE_ZAKAZKA_DATA](state) {
			state.props.zakazkaData = {
				ZakazkaId: state.edit.ZakazkaId,
				ZakazkaIdNr: state.edit.ZakazkaIdNr,
				ZakazkaIdDruh: state.edit.ZakazkaIdDruh,
				OzakazkaId: state.edit.OzakazkaId,
				OzakazkaIdNr: state.edit.OzakazkaIdNr,
				OzakazkaIdText: state.edit.OzakazkaIdText,
			};
		},
		[types.mutations.NDREZ_SET_ZAKAZKA_DATA](state) {
			_.assign(state.edit, state.props.zakazkaData);
		},
	},
	props: {
		filter: {
			ZakazkaId: null as number | null,
			NdNr: null as string | null,
			VyrobekndOzn: null as string | null,
			SkladOzn: null as number | null,
		},
		mode: null,
		zakazkaData: {},
		jfnd: {
			row: null as Cell[] | null,
			options: null as {} | null,
		},
	},
});
